import { Component, OnInit, Input } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'g-columnList',
  templateUrl: './columnList.component.html',
})
export class ColumnListComponent implements OnInit {
  constructor() { }

  htmlData: any = "";
  isDelimiter:boolean;
  showFirst: boolean;
  private _delimiter = "";
  text:string;
  private _data: string[];
  @Input() set data(d: string[]) {
    this._data = d;
    if (Array.isArray(d) && d.length > 0) {
      this.htmlData = this.data.join((this.isDelimiter ? this.delimiter : ',') + " ");
    }
  }
  get data() {
    return this._data;
  }
  @Input() isEditing: boolean = false;
  @Input() set delimiter(s: string) {
    this._delimiter = s ? s : "";
    this.isDelimiter = s !== undefined && s !== null && s !== '';
    if (s === "fst(+n)") {
      this._delimiter = ",";
      this.showFirst = true;
    }
  }
  get delimiter() {
    return this._delimiter;
  }  

  ngOnInit() {
    if (this.showFirst && this.data) {
      this.text = this.data.length === 1 ?  this.data[0] : 
                  this.data.length > 1 ? this.data[0] + " (+" + (this.data.length - 1) + ")" :
                  "";
    }

  }
}
